"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _trackAccountSelectOpen = require("./trackAccountSelectOpen");
Object.keys(_trackAccountSelectOpen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _trackAccountSelectOpen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _trackAccountSelectOpen[key];
    }
  });
});
var _trackAccountSelectNeedHelp = require("./trackAccountSelectNeedHelp");
Object.keys(_trackAccountSelectNeedHelp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _trackAccountSelectNeedHelp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _trackAccountSelectNeedHelp[key];
    }
  });
});